import { motion, AnimatePresence } from 'framer-motion'

interface DraftRecoveryBannerProps {
  isVisible: boolean
  mediaCount: number
  hasFormData?: boolean
  onRecover: () => void
  onDiscard: () => void
}

export function DraftRecoveryBanner({
  isVisible,
  mediaCount,
  hasFormData = false,
  onRecover,
  onDiscard,
}: DraftRecoveryBannerProps) {
  // Build description based on what's in the draft
  const getDescription = () => {
    if (mediaCount > 0 && hasFormData) {
      return `You have ${mediaCount} media file${mediaCount !== 1 ? 's' : ''} and text from an unfinished exercise.`
    } else if (mediaCount > 0) {
      return `You have ${mediaCount} media file${mediaCount !== 1 ? 's' : ''} from an unfinished exercise.`
    } else if (hasFormData) {
      return 'You have text from an unfinished exercise.'
    }
    return 'You have an unfinished exercise.'
  }
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
          className="mb-4 p-4 rounded-xl border border-cyan-200 dark:border-cyan-500/30 bg-cyan-50 dark:bg-cyan-500/10 backdrop-blur-sm"
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-100 dark:bg-cyan-500/20 flex items-center justify-center">
              <svg className="w-4 h-4 text-cyan-600 dark:text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-cyan-900 dark:text-cyan-100">
                Unsaved work found
              </h4>
              <p className="text-xs text-cyan-700 dark:text-cyan-300/80 mt-0.5">
                {getDescription()} Would you like to continue where you left off?
              </p>
            </div>
          </div>
          <div className="flex gap-2 mt-3 ml-11">
            <button
              onClick={onRecover}
              className="px-3 py-1.5 text-xs font-medium rounded-lg bg-cyan-500 hover:bg-cyan-400 text-white transition-colors"
            >
              Continue editing
            </button>
            <button
              onClick={onDiscard}
              className="px-3 py-1.5 text-xs font-medium rounded-lg border border-cyan-200 dark:border-cyan-500/30 text-cyan-700 dark:text-cyan-300 hover:bg-cyan-100 dark:hover:bg-cyan-500/10 transition-colors"
            >
              Discard
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
